import { getColumnWidth, isUtilityGridColumn } from '../utils';

type GridColumn = {
  id: string;
  getSize: () => number;
  columnDef: {
    meta?: unknown;
  };
};

const MOBILE_MIN_COLUMN_WIDTH = 140;
const PIXEL_WIDTH_PATTERN = /^\d+(?:\.\d+)?(?:px)?$/;

const getPixelWidth = (width: string): number | null => {
  const normalizedWidth = width.trim();
  if (!PIXEL_WIDTH_PATTERN.test(normalizedWidth)) return null;

  const pixelWidth = Number.parseFloat(normalizedWidth);
  return Number.isFinite(pixelWidth) ? pixelWidth : null;
};

export const getRenderedColumnWidth = (column: GridColumn, isSmallMobile: boolean): string => {
  const width = getColumnWidth(column);
  const pixelWidth = getPixelWidth(width);

  if (!isSmallMobile || isUtilityGridColumn(column.id) || pixelWidth === null) {
    return width;
  }

  return `${Math.max(pixelWidth, MOBILE_MIN_COLUMN_WIDTH)}px`;
};

export const getVisibleTableWidth = (columns: GridColumn[], isSmallMobile: boolean): number =>
  columns.reduce((total, column) => {
    const renderedWidth = getRenderedColumnWidth(column, isSmallMobile);
    const pixelWidth = getPixelWidth(renderedWidth);

    return total + (pixelWidth ?? column.getSize());
  }, 0);
